import { defineStore } from "pinia";
import authService from "@/services/AuthService";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: localStorage.getItem("token"),
    ip: localStorage.getItem("ip"),
  }),

  actions: {
    async setToken() {
      if (this.token || !this.ip) return;

      const res = await authService.token(this.ip);

      this.token = res.data?.token;

      if (this.token) localStorage.setItem("token", this.token);
    },
    unsetToken() {
      this.token = null;
    },
  },
});
